import {
  CommonModule,
} from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  O3rComponent,
} from '@o3r/core';
import {
  RequestParametersService,
} from '@o3r/dynamic-content';
import {
  BasicLayoutModule,
  IdentificationSkeletonPresComponent,
  NavigationMenuSkeletonComponent,
  PageTitleSkeletonPresComponent,
  PassengerRecapSkeletonPresComponent,
} from '@refx/shared-components';
import {
  JourneySelectionSkeletonComponent,
  TimingRecapSkeletonComponent,
} from '@refx/ssci-components';
import {
  DeeplinkTargetService,
} from '@refx/ssci-services';
import {
  NgxSkeletonLoaderModule,
} from 'ngx-skeleton-loader';
import {
  Observable,
  of,
} from 'rxjs';
import {
  skeletalRoutes,
  SsciRoutes,
} from '../../configuration';

@O3rComponent({
  componentType: 'Component'
})
@Component({
  selector: 'refx-app-skeleton-pres',
  templateUrl: './app-skeleton-pres.template.html',
  styleUrls: ['./app-skeleton-pres.style.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BasicLayoutModule,
    CommonModule,
    IdentificationSkeletonPresComponent,
    JourneySelectionSkeletonComponent,
    NavigationMenuSkeletonComponent,
    NgxSkeletonLoaderModule,
    PageTitleSkeletonPresComponent,
    PassengerRecapSkeletonPresComponent,
    TimingRecapSkeletonComponent
  ]
})
export class AppSkeletonPresComponent {
  /**
   * The route for which the skeleton must be displayed
   */
  public skeletonRoute$: Observable<string>;

  constructor(
    private readonly requestParametersService: RequestParametersService,
    private readonly deeplinkTargetService: DeeplinkTargetService
  ) {
    this.determineSkeletonPage();
    this.setDeeplingTargetRoute();
  }

  /**
   * Determine which skeleton to display based on the route
   */
  protected determineSkeletonPage() {
    const route = window.location.pathname;
    const skeletonRoute = skeletalRoutes.find((skeletalRoute) => route.includes(skeletalRoute));
    this.skeletonRoute$ = skeletonRoute ? of(skeletonRoute) : this.deeplinkTargetService.skeletonRoute$;
  }

  /**
   * Set the target route for the deepling based on the request parameters
   */
  protected setDeeplingTargetRoute() {
    const requestParams = this.requestParametersService.getParams();
    if (!requestParams?.identifier || !requestParams?.lastName) {
      this.deeplinkTargetService.setTargetRoute(SsciRoutes.identification);
    } else {
      this.deeplinkTargetService.setTargetRoute(SsciRoutes.journeySelection);
    }
  }
}
